import { Logo } from "@/components/Navbar";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t bg-white">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:px-6 md:grid-cols-3 lg:px-8">
        <div className="space-y-3">
          <Logo testid="footer-logo" />
          <p className="max-w-xs text-sm text-stone-600">Stays without the guest service fee. Hosts pay a flat 10%, and that's all we take.</p>
        </div>
        <div className="text-sm text-stone-600">
          <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-stone-500">Our fee promise</p>
          <p>Guests: $0 service fee. Hosts: 10% commission. Nothing hidden at checkout.</p>
        </div>
        <div className="text-sm text-stone-600" data-testid="footer-complaint-policy">
          <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-stone-500">Fair complaints</p>
          <p>Both sides share photos and statements, and a real person on our team reviews every case.</p>
          <div className="mt-3 flex flex-col gap-1">
            <Link to="/non-discrimination" className="font-semibold text-primary hover:underline" data-testid="footer-nondiscrimination-link">Non-discrimination policy</Link>
            <Link to="/guest-terms" className="font-semibold text-primary hover:underline" data-testid="footer-guest-terms-link">Guest Terms</Link>
            <Link to="/host-agreement" className="font-semibold text-primary hover:underline" data-testid="footer-host-agreement-link">Host Agreement</Link>
            <Link to="/terms-of-service" className="font-semibold text-primary hover:underline" data-testid="footer-terms-link">Terms of Service</Link>
            <Link to="/privacy-policy" className="font-semibold text-primary hover:underline" data-testid="footer-privacy-link">Privacy Policy</Link>
          </div>
        </div>
      </div>
      <p className="pb-8 text-center text-xs text-stone-400">Airbnb and Vrbo comparisons are estimates using typical published fees (Nov 2026): Airbnb's 15.5% host-only fee or older split fee (3% host + about 14.1% guest), and Vrbo's 12% commission plus a traveler fee of about 10%, which varies. Real fees vary by account and pricing.</p>
    </footer>
  );
}
